(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dv-polish"] && !Shopify.designMode) return;
  try {
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) { const observer = new IntersectionObserver(entries => { entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }); }, {threshold: .08}); document.querySelectorAll('.dv-reveal').forEach(element => observer.observe(element)); }
const dvMenuButton = document.querySelector('.dv-menu-toggle');
const dvMenuPanel = document.querySelector('.dv-mobile-panel');
if (dvMenuButton && dvMenuPanel) {
  const dvMenuLinks = dvMenuPanel.querySelectorAll('a');
  const setMenuOpen = (opening) => {
    dvMenuButton.setAttribute('aria-expanded', String(opening));
    dvMenuPanel.setAttribute('aria-hidden', String(!opening));
    dvMenuPanel.inert = !opening;
    dvMenuLinks.forEach(link => { link.tabIndex = opening ? 0 : -1; });
  };
  dvMenuButton.addEventListener('click', () => {
    const opening = dvMenuButton.getAttribute('aria-expanded') !== 'true';
    setMenuOpen(opening);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && dvMenuButton.getAttribute('aria-expanded') === 'true') {
      setMenuOpen(false);
      dvMenuButton.focus();
    }
  });
}

(() => {
  const selector = 'button, a, summary';
  const excluded = '.product,.dv-product,.product-single__photos,#ProductThumbs,.product-single__featured-image-wrapper,.mfp-wrap,.shopify-payment-button,.dv-wordmark';
  const decorate = root => {
    root.querySelectorAll(selector).forEach(el => {
      if (el.closest(excluded) || el.querySelector('img') || el.classList.contains('dv-border-glow') || el.classList.contains('skip-link')) return;
      el.classList.add('dv-border-glow');
      el.addEventListener('pointermove', event => {
        if (event.pointerType === 'touch' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const rect = el.getBoundingClientRect();
        const dx = event.clientX - rect.left - rect.width / 2;
        const dy = event.clientY - rect.top - rect.height / 2;
        el.style.setProperty('--cursor-angle', `${Math.atan2(dy, dx) * 180 / Math.PI + 90}deg`);
      }, {passive:true});
    });
  };
  const start = () => {
    decorate(document);
    new MutationObserver(records => {
      if (records.some(record => record.addedNodes.length)) decorate(document);
    }).observe(document.body, {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dv-size-picker"] && !Shopify.designMode) return;
  try {
    (() => {
  const initSizePicker = () => {
    const section = document.querySelector('#ProductSection');
    if (!section || section.querySelector('.dv-size-picker')) return;
    const dataNode = document.getElementById('ProductJson-' + section.dataset.sectionId);
    if (!dataNode) return;
    let product;
    try { product = JSON.parse(dataNode.textContent); } catch (_) { return; }
    const sizeIndex = (product.options || []).findIndex(name => /size/i.test(name));
    if (sizeIndex < 0) return;
    const selects = [...section.querySelectorAll('.selector-wrapper select.single-option-selector')];
    const sizeSelect = selects.find(select => select.dataset.option === `option${sizeIndex + 1}`);
    if (!sizeSelect) return;
    const values = [...sizeSelect.options].map(option => option.value);
    if (!values.length) return;
    const group = document.createElement('div');
    group.className = 'dv-size-picker';
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', product.options[sizeIndex]);
    const chips = values.map(value => {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'dv-size-chip';
      chip.setAttribute('role', 'radio');
      chip.dataset.value = value;
      const label = document.createElement('span');
      label.textContent = ({Small:'S',Medium:'M',Large:'L','X-Large':'XL','2X-Large':'2XL','3X-Large':'3XL'})[value] || value;
      chip.appendChild(label);
      const status = document.createElement('small');
      status.textContent = theme.strings.soldOut;
      status.style.cssText = 'display:none;font-size:8px;line-height:1.3;margin-top:4px';
      chip.appendChild(status);
      group.appendChild(chip);
      return chip;
    });
    const availableFor = value => (product.variants || []).some(variant => {
      if (!variant.available || variant.options[sizeIndex] !== value) return false;
      return selects.every(select => { const index = Number(select.dataset.option.replace('option','')) - 1; return index === sizeIndex || variant.options[index] === select.value; });
    });
    const sync = () => {
      chips.forEach(chip => {
        const selected = chip.dataset.value === sizeSelect.value;
        const soldOut = !availableFor(chip.dataset.value);
        chip.setAttribute('aria-checked', String(selected));
        chip.setAttribute('aria-label', soldOut ? `${chip.dataset.value}, ${theme.strings.soldOut}` : chip.dataset.value);
        chip.dataset.soldOut = String(soldOut);
        chip.disabled = soldOut;
        chip.querySelector('small').style.display = soldOut ? 'block' : 'none';
        chip.tabIndex = selected && !soldOut ? 0 : -1;
      });
      if (!chips.some(chip => chip.tabIndex === 0)) { const first = chips.find(chip => !chip.disabled); if (first) first.tabIndex = 0; }
    };
    const animateSelection = selected => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      chips.forEach((chip, index) => {
        chip.getAnimations().forEach(animation => animation.cancel());
        const direction = Math.sign(index - selected);
        const shift = direction * 6;
        const on = index === selected;
        chip.animate(on ? [
          {transform:'scale(1)'},{transform:'scale(1.2,.9)',offset:.22},{transform:'scale(1.08,1.17)',offset:.46},{transform:'scale(1.14,1.08)',offset:.7},{transform:'scale(1.1)'}
        ] : [
          {transform:'translateX(0) scale(1)'},{transform:`translateX(${shift * 1.2}px) scale(.94)`,offset:.45},{transform:`translateX(${shift}px) scale(.95)`}
        ], {duration:550,delay:Math.abs(index-selected)*22,easing:'cubic-bezier(.2,.7,.3,1)',fill:'forwards'});
      });
    };
    chips.forEach((chip, index) => {
      chip.addEventListener('click', () => {
        if (chip.disabled || sizeSelect.value === chip.dataset.value) return;
        sizeSelect.value = chip.dataset.value;
        sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        animateSelection(index);
        sync();
      });
      chip.addEventListener('animationend', () => chip.classList.remove('dv-jelly'));
      chip.addEventListener('keydown', event => {
        const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 0;
        if (!direction && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        const step = event.key === 'Home' ? 0 : event.key === 'End' ? chips.length - 1 : index + direction;
        for (let offset = 0; offset < chips.length; offset++) {
          const next = chips[(step + offset * (direction || 1) + chips.length) % chips.length];
          if (!next.disabled) { next.click(); next.focus(); break; }
        }
      });
    });
    sizeSelect.closest('.selector-wrapper').style.width = '100%';
    sizeSelect.classList.add('dv-size-native');
    sizeSelect.tabIndex = -1;
    sizeSelect.setAttribute('aria-hidden','true');
    sizeSelect.insertAdjacentElement('afterend', group);
    selects.forEach(select => select.addEventListener('change', sync));
    sync();
  };
  if (document.readyState === 'complete') initSizePicker();
  else window.addEventListener('load', initSizePicker, { once: true });
  document.addEventListener('shopify:section:load', initSizePicker);
})();
  } catch(e) { console.error(e); }
})();

})();
